// extracted by mini-css-extract-plugin
module.exports = {"scrollToTopBtn":"ScrollToTopBtn_scrollToTopBtn__3IR1V","fadeIn":"ScrollToTopBtn_fadeIn__dY4Bl","fadeOut":"ScrollToTopBtn_fadeOut__3YvWA"};